import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

function formatErr(detail) {
  if (!detail) return "Anmeldung fehlgeschlagen.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((e) => e.msg || "").join(" ");
  return String(detail);
}

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await login(email, password);
      toast.success("Willkommen zurück.");
      navigate("/admin");
    } catch (err) {
      setError(formatErr(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen bg-prussian flex items-center justify-center px-4 notranslate">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <Link to="/" className="font-headline font-bold text-white text-3xl tracking-[0.08em]">KONTINENTZEIT</Link>
          <p className="text-white/50 text-xs uppercase tracking-widest mt-2 font-body">Redaktionssystem · Anmeldung</p>
        </div>
        <form onSubmit={submit} data-testid="admin-login-form" className="bg-white p-8 shadow-xl">
          <h1 className="font-headline font-bold text-2xl text-prussian mb-6">Anmelden</h1>
          {error && <div data-testid="login-error" className="bg-breaking/10 border border-breaking text-breaking text-sm px-4 py-3 mb-4 font-body">{error}</div>}
          <label className="block text-xs uppercase tracking-wide text-muted-foreground font-body mb-1.5">E-Mail</label>
          <input data-testid="login-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)}
            className="w-full border border-edborder px-4 py-3 text-sm outline-none focus:border-prussian mb-4" />
          <label className="block text-xs uppercase tracking-wide text-muted-foreground font-body mb-1.5">Passwort</label>
          <input data-testid="login-password-input" type="password" required value={password} onChange={(e) => setPassword(e.target.value)}
            className="w-full border border-edborder px-4 py-3 text-sm outline-none focus:border-prussian mb-6" />
          <button data-testid="login-submit-btn" type="submit" disabled={loading}
            className="w-full bg-prussian text-white font-body font-semibold text-sm uppercase tracking-wide py-3 hover:bg-prussian-dark transition-colors disabled:opacity-50">
            {loading ? "Anmeldung…" : "Anmelden"}
          </button>
        </form>
        <p className="text-center text-white/40 text-xs mt-6 font-body">Nur für autorisierte Redaktionsmitglieder.</p>
      </div>
    </div>
  );
}
